// test527
(527 && 0);
